import useIdle from 'hooks/useIdle';

export default function useApp() {
	useIdle();
}
